<template>
  <div style="overflow: hidden">
    <div v-transfer-dom>
      <popup v-model="show1">
        <popup-header
          left-text="取消"
          right-text="确定"
          title="请选择银行"
          :show-bottom-border="false"
          @on-click-left="show1 = false"
          @on-click-right="confirm"
        >
        </popup-header>
        <group gutter="0">
          <div class="flex vux-1px-b">
            <input
              class="searchInput flex1"
              v-model="search.name"
              placeholder="请输入银行名称"
            />
            <span class="searchButton" @click="getBankList">搜索</span>
          </div>
          <picker :data="bankList" v-model="bankName"></picker>
        </group>
      </popup>
    </div>
  </div>
</template>

<script>
import { PopupHeader, Popup, Group, Picker } from "vux";
import { getBankList } from "../../../api/bank";
export default {
  name: "bankList",
  components: {
    PopupHeader,
    Popup,
    Group,
    Picker
  },
  data() {
    return {
      show1: false,
      params: {
        bank: "",
        code: ""
      },
      search: {
        name: ""
      },
      bankList: [],
      bankName: [""]
    };
  },
  created() {
    this.getBankList();
  },
  methods: {
    confirm() {
      this.show1 = false;
      this.params.bank = this.bankName[0];
      for (let i = 0; i < this.bankList[0].length; i++) {
        if (this.bankList[0][i].name == this.bankName[0]) {
          this.params.code = this.bankList[0][i].code;
        }
      }
      this.$emit("getBankInfo", this.params);
    },
    getBankList() {
      getBankList(this.search)
        .then(res => {
          this.bankList = [];
          let bankList = [];
          for (let i = 0; i < res.length; i++) {
            res[i].key = res[i].name;
            res[i].value = res[i].name;
            bankList.push(res[i]);
          }
          this.bankList.push(bankList);
        })
        .catch(err => {
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.searchInput {
  font-size: 14px;
  border: 1px solid #e8e8e8;
  margin: 20px 0 20px 20px;
  border-radius: 10px;
  padding: 10px 20px;
  height: 40px;
}
.searchButton {
  margin: 20px 10px;
  padding: 10px 0;
  display: inline-block;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
}
</style>
